import React from 'react';

interface DownloadCircleIconProps {
    colour?: string;
    width?: string | number;
    height?: string | number;
}

const DownloadCircleIcon = ({ colour = 'currentColor', width = 16, height = 16 }: DownloadCircleIconProps) => (
    <svg
        data-testid="download-circle-icon"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 0C3.592 0 0 3.592 0 8C0 12.408 3.592 16 8 16C12.408 16 16 12.408 16 8C16 3.592 12.408 0 8 0ZM7.2 6.40002V4.00002C7.2 3.56002 7.56 3.20002 8 3.20002V3.20002C8.44 3.20002 8.8 3.56002 8.8 4.00002V6.40002H10.232C10.592 6.40002 10.768 6.83202 10.512 7.08002L8.28 9.31202C8.12 9.47202 7.872 9.47202 7.712 9.31202L5.48 7.08002C5.232 6.83202 5.408 6.40002 5.768 6.40002H7.2ZM11.2 11.9999H4.8C4.36 11.9999 4 11.6399 4 11.1999V11.1999C4 10.7599 4.36 10.3999 4.8 10.3999H11.2C11.64 10.3999 12 10.7599 12 11.1999V11.1999C12 11.6399 11.64 11.9999 11.2 11.9999Z"
            fill={colour}
        />
    </svg>
);

export default DownloadCircleIcon;
